/**
 * External dependencies.
 */

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styles( props, selector = false ) {
	const css = '';
	console.log( props );
	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styles;
